/*
 *
 *
 *
 *
 * For now this is not used as there is no need to merge messages as the contact is selected
 * contcts store is used and there is a hook for selecting a contact from the contact DB object from contacts
 */

import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  Contact,
  Message,
  Booking,
  Escalation,
  ToolCall,
  apiResult,
  Company,
} from "../interfaces";
import { adaptItem } from "../utils/contacts";

const adaptNewContact = (
  newContact: apiResult,
  previousMessages: Message[] = []
): Pick<
  ContactStoreState,
  | "contact"
  | "messages"
  | "bookings"
  | "escalations"
  | "companies"
  | "toolCalls"
> => {
  const { contact, messages, bookings, escalations, companies, toolCalls } =
    adaptItem(newContact);

  return {
    contact,
    messages,
    bookings,
    escalations,
    companies,
    toolCalls,
  };
};

export interface ContactData {
  loading: boolean;
  id: string;
  contact: Contact;
  messages: Message[];
  bookings: Booking[];
  escalations: Escalation[];
  toolCalls: ToolCall[];
  companies: Company[];
}

interface ContactStoreState extends ContactData {
  setContactId: (id: string) => void;
  setLoading: (loading: boolean) => void;
  setContact: (contact: apiResult) => void;
  newMessage: (contacts: apiResult[]) => void;
  reset: () => void;
}

export const contactInitialState: ContactData = {
  id: "",
  loading: false,
  contact: {
    type: "list",
    id: "",
    name: "",
    preview: "",
    unread: 0,
    timestamp: "",
    enabled: false,
    optedOut: false,
    manual: false,
    blocked: false,
    archive: false,
    phoneNumber: "",
    status: "",
    escalated: false,
    isBook: false,
    isManual: false,
    isPayment: false,
    isBooked: false,
    isOnline: false,
    timestampNative: new Date().getTime(),
    count: 0,
    followers: 0,
    username: "",
    companies: [],
    assignations: [],
  },
  messages: [],
  bookings: [],
  escalations: [],
  toolCalls: [],
  companies: [],
};

const useContactStore = create(
  devtools<ContactStoreState>((set, get) => ({
    ...contactInitialState,
    setContactId: (id) => {
      const { id: stateContactId } = get() || {};
      return set({
        ...(stateContactId !== id ? contactInitialState : {}),
        id,
      });
    },
    setLoading: (loading) => set({ loading }),
    setContact: (newContact) => {
      const { messages = [] } = get() || {};
      const adaptedContact = adaptNewContact(newContact, messages);
      return set({
        id: newContact._id,
        loading: false,
        ...adaptedContact,
      });
    },
    newMessage: (contacts) => {
      const state = get() || {};
      const matches = contacts.filter((c: any) => c._id === state.id);
      if (matches.length === 1) {
        const [match] = matches;
        const adaptedContact = adaptNewContact(match);
        return set({ ...adaptedContact });
      }
    },
    reset: () => set({ ...contactInitialState }),
  }))
);

const selectContactData = (state: ContactStoreState) => ({
  id: state.id,
  loading: state.loading,
  contact: state.contact,
  messages: state.messages,
  bookings: state.bookings,
  escalations: state.escalations,
  toolCalls: state.toolCalls,
  companies: state.companies,
});

const selectContactActions = (state: ContactStoreState) => ({
  setContactId: state.setContactId,
  setLoading: state.setLoading,
  setContact: state.setContact,
  newMessage: state.newMessage,
  resetContact: state.reset,
});

export const useContactData = () => useContactStore(selectContactData);
export const useContactActions = () => useContactStore(selectContactActions);
export default useContactStore;
